export default "__VITE_ASSET__xxwjVots__"